/**
 * ChallengeRankCard component - Neo-Brutalist Design
 * Displays individual challenge ranking with stats
 */

import type { ChallengeRanking } from '../types';

interface ChallengeRankCardProps {
  challenge: ChallengeRanking;
  rank: number;
}

export function ChallengeRankCard({ challenge, rank }: ChallengeRankCardProps) {
  const isTopRank = rank <= 3;

  return (
    <div className={`challenge-card ${isTopRank ? 'top-rank' : ''}`}>
      <div className="challenge-card-content">
        {/* Rank Badge */}
        <div className={`rank-badge ${isTopRank ? 'top-rank' : ''}`}>
          #{rank}
        </div>

        {/* Challenge Info */}
        <div className="challenge-info">
          <div className="challenge-name-row">
            <h3 className="challenge-name">
              {challenge.name}
            </h3>
            <span className={`priority-badge priority-${challenge.priority}`}>
              {challenge.priority}
            </span>
          </div>

          <p className="challenge-description">{challenge.description}</p>

          <div className="challenge-stats">
            <div className="question-count">
              <span className="count-number">{challenge.count}</span>
              <span className="count-label">
                question{challenge.count !== 1 ? 's' : ''}
              </span>
            </div>

            <div className="progress-bar">
              <div
                className="progress-fill"
                style={{ width: `${challenge.percentage}%` }}
              />
            </div>

            <div className="percentage">{challenge.percentage.toFixed(1)}%</div>
          </div>
        </div>
      </div>
    </div>
  );
}
